module.exports=[
  {
    "candidate": "Undecided",
    "ballot1": .19,
    "ballot2": .0
  },
  {
    "candidate": "Eric Brakey",
    "ballot1": .19,
    "ballot2": .14
  },
  {
    "candidate": "Adrienne Bennett",
    "ballot1": .25,
    "ballot2": .17
  },
  {
    "candidate": "Dale Crafts",
    "ballot1": .37,
    "ballot2": .0
  }
]
